/* Fishmaster cart upsell: adds a cheap item from the cart drawer and refreshes it */
(function () {
  if (window.__fmUpsellInit) return;
  window.__fmUpsellInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fm-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');

    var drawer = document.querySelector('cart-drawer');
    var body = JSON.stringify({
      items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1, properties: { _source: 'cart-upsell' } }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    });

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { throw new Error(state.description || 'add failed'); }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });
})();
